export function getSearchPagePath(lang: string | undefined) {
    switch (lang) {
        case 'da':
            return '/soeg';
        case 'sv':
            return '/soeka';
        case 'no':
            return '/soek';
        case 'en':
        default:
            return '/search';
    }
}
